import {
  PRODUCT_TYPE_DELIVERY,
  PRODUCT_TYPE_EXTENSION,
  PRODUCT_TYPE_RENTAL_DIRECT,
  PRODUCT_TYPE_RENTAL_SMS,
} from '../../../controller/OrderController';
import {
  APP_NAME_KNOCKKNOCK,
  ORDER_CANCLE_STATUS,
  ORDER_COM_COOK_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  ORDER_READY_STATUS,
  ORDER_START_DEL_STATUS,
  ORDER_WAIT_STATUS,
} from '../../../utils/DataType';

export const getDeliveryComment = (appName: string, deliveryStatus: number) => {
  if (appName === APP_NAME_KNOCKKNOCK) {
    if (deliveryStatus === 0) return '주문 접수 전';
    else if (deliveryStatus === 1) return '조리중';
    else if (deliveryStatus === 2) return '조리완료';
    else if (deliveryStatus === 3) return '배달중';
    else if (deliveryStatus === 4) return '배달완료';
    return '에러';
  }
};

export const getStatusTypeList = (order_category: number) => {
  if (order_category === PRODUCT_TYPE_DELIVERY) {
    return [
      ORDER_WAIT_STATUS,
      ORDER_READY_STATUS,
      ORDER_COM_COOK_STATUS,
      ORDER_START_DEL_STATUS,
      ORDER_COM_DEL_STATUS,
    ];
  } else if (order_category === PRODUCT_TYPE_EXTENSION) {
    return [ORDER_COM_DEL_STATUS];
  } else if (order_category === PRODUCT_TYPE_RENTAL_DIRECT) {
    return [ORDER_WAIT_STATUS, ORDER_READY_STATUS, ORDER_START_DEL_STATUS, ORDER_COM_DEL_STATUS];
  } else if (order_category === PRODUCT_TYPE_RENTAL_SMS) {
    return [ORDER_WAIT_STATUS, ORDER_READY_STATUS, ORDER_COM_STATUS];
  } else return [];
};

export const getStoreTypeStatus = (order_category: number, status: number) => {
  if (order_category === PRODUCT_TYPE_DELIVERY) {
    switch (status) {
      case ORDER_WAIT_STATUS:
        return {
          position: 5,
          button_position: 4,
          status_name: '주문확인',
          button: '주문\n접수',
          toast: '주문접수 되었습니다',
        };
      case ORDER_READY_STATUS:
        return {
          position: 27.5,
          button_position: 26.5,
          status_name: '조리중',
          button: '조리\n완료',
          toast: '조리완료 되었습니다',
        };
      case ORDER_COM_COOK_STATUS:
        return {
          position: 50,
          button_position: 49,
          status_name: '조리완료',
          button: '픽업\n완료',
          toast: '픽업완료 되었습니다',
        };
      case ORDER_START_DEL_STATUS:
        return {
          position: 72.5,
          button_position: 71.5,
          status_name: '배달중',
          button: '배달\n완료',
          toast: '배달완료 되었습니다',
        };
      case ORDER_COM_DEL_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '배달완료',
          button: '주문\n완료',
          toast: '',
        };
      case ORDER_COM_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '배달완료',
          button: '주문\n완료',
          toast: '',
        };
      case ORDER_CANCLE_STATUS:
        return {
          position: 0,
          button_position: 0,
          status_name: '주문취소',
          button: '결제\n취소',
          toast: '',
        };
      default:
        return {
          position: 0,
          button_position: 0,
          status_name: '',
          button: '',
          toast: '',
        };
    }
  } else if (order_category === PRODUCT_TYPE_EXTENSION) {
    switch (status) {
      case ORDER_WAIT_STATUS:
        return {
          position: 5,
          button_position: 4,
          status_name: '주문확인',
          button: '연장\n완료',
          toast: '',
        };
      case ORDER_COM_DEL_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '연장완료',
          button: '연장\n완료',
          toast: '',
        };
      case ORDER_COM_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '연장완료',
          button: '연장\n완료',
          toast: '',
        };
      case ORDER_CANCLE_STATUS:
        return {
          position: 0,
          button_position: 0,
          status_name: '주문취소',
          button: '결제\n취소',
          toast: '',
        };
      default:
        return {
          position: 0,
          button_position: 0,
          status_name: '',
          button: '',
          toast: '',
        };
    }
  } else if (order_category === PRODUCT_TYPE_RENTAL_DIRECT) {
    switch (status) {
      case ORDER_WAIT_STATUS:
        return {
          position: 5,
          button_position: 4,
          status_name: '주문확인',
          button: '주문\n접수',
          toast: '주문접수 되었습니다',
        };
      case ORDER_READY_STATUS:
        return {
          position: 33,
          button_position: 32,
          status_name: '상품 준비중',
          button: '준비\n완료',
          toast: '준비완료 되었습니다',
        };
      case ORDER_START_DEL_STATUS:
        return {
          position: 63,
          button_position: 62,
          status_name: '전달중',
          button: '전달\n완료',
          toast: '전달완료 되었습니다',
        };
      case ORDER_COM_DEL_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '전달완료',
          button: '전달\n완료',
          toast: '',
        };
      case ORDER_COM_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '전달완료',
          button: '전달\n완료',
          toast: '',
        };
      case ORDER_CANCLE_STATUS:
        return {
          position: 0,
          button_position: 0,
          status_name: '주문취소',
          button: '결제\n취소',
          toast: '',
        };
      default:
        return {
          position: 0,
          button_position: 0,
          status_name: '',
          button: '',
          toast: '',
        };
    }
  } else if (order_category === PRODUCT_TYPE_RENTAL_SMS) {
    switch (status) {
      case ORDER_WAIT_STATUS:
        return {
          position: 5,
          button_position: 4,
          status_name: '주문확인',
          button: '예약\n확정',
          toast: '예약확정 되었습니다',
        };
      case ORDER_READY_STATUS:
        return {
          position: 49,
          button_position: 48,
          status_name: '예약확정',
          button: '사용\n완료',
          toast: '사용완료 되었습니다',
        };
      case ORDER_COM_DEL_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '사용완료',
          button: '사용\n완료',
          toast: '',
        };
      case ORDER_COM_STATUS:
        return {
          position: 100,
          button_position: 94,
          status_name: '사용완료',
          button: '사용\n완료',
          toast: '',
        };
      case ORDER_CANCLE_STATUS:
        return {
          position: 0,
          button_position: 0,
          status_name: '주문취소',
          button: '결제\n취소',
          toast: '',
        };
      default:
        return {
          position: 0,
          button_position: 0,
          status_name: '',
          button: '',
          toast: '',
        };
    }
  } else {
    return {
      position: 0,
      button_position: 0,
      status_name: '',
      button: '',
      toast: '',
    };
  }
};
